import { render, staticRenderFns } from "./Teams.vue?vue&type=template&id=6aed78fc&scoped=true"
import script from "./Teams.js?vue&type=script&lang=js&external"
export * from "./Teams.js?vue&type=script&lang=js&external"
import style0 from "./Teams.vue?vue&type=style&index=0&id=6aed78fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aed78fc",
  null
  
)

export default component.exports